import React from 'react'
import { Container } from 'semantic-ui-react'
import PageHeader from '../components/PageHeader'

export default function Contact() {
  return (
    <>
      <PageHeader
        title="Contact Us"
        image="/images/tree-fallen.jpg"
        backgroundPositionY="100"
      />
      <Container>
        <div className="mb-5">
          <h3>
            Call or text us at{' '}
            <a href="tel:240-560-8733">240-560-TREE (8733)</a>
          </h3>
          <h3>Text us your address and we will schedule a time to do a bid.</h3>
        </div>
      </Container>
    </>
  )
}
